import { useTranslation } from "@/packages/utils";
import { ClauseRefsGroup } from "@/components/audits/ClauseRefBadge";
import type { ClauseInfoWithRef } from "@/components/audits/ClauseRefBadge";
import type { UIChecklistItem } from "@/packages/types";

export function OverviewContent({ item }: { item: UIChecklistItem }) {
  const { t } = useTranslation("audits");

  const clauseRefs = item.clauseDetails?.map((c) => c.clauseNumber) ?? [];
  const clauseInfo: ClauseInfoWithRef[] =
    item.clauseDetails?.map((c) => ({
      ref: c.clauseNumber,
      standard: c.clauseNumber.split(" ")[0] ?? "",
      title: c.title,
      description: c.description ?? "",
    })) ?? [];

  return (
    <div className="space-y-4">
      {/* Description */}
      {item.description && (
        <div>
          <h4 className="text-xs font-medium text-muted uppercase tracking-wider mb-1.5">
            {t("checklist.overview.description")}
          </h4>
          <p className="text-[13px] text-secondary leading-relaxed">
            {item.description}
          </p>
        </div>
      )}

      {/* Clause references */}
      {clauseRefs.length > 0 && (
        <div>
          <h4 className="text-xs font-medium text-muted uppercase tracking-wider mb-1.5">
            {t("checklist.overview.clauseReferences")}
          </h4>
          <ClauseRefsGroup clauseRefs={clauseRefs} clauseInfo={clauseInfo} />
        </div>
      )}
    </div>
  );
}
